import React from 'react';

const Progress = ({ value, className = '', ...props }) => {
    return (
        <div
            className={`relative h-2 w-full overflow-hidden rounded-full bg-gray-300 ${className}`}
            {...props}
        >
            <div
                className="h-full w-full flex-1 transition-all"
                style={{ transform: `translateX(-${100 - (value || 0)}%)`, backgroundColor: props.color || "#3B0069" }}
            />
        </div>
    );
};

export { Progress };
